var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('crud',{attrs:{"config":_vm.config},on:{"comment":_vm.comment}}),_c('VideoCommentList',{ref:"commentList"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }